import IBModuleApi from "../../api/iuviBankingAPI";
import { urlContexts } from "../../constants";

export const getTenantBranding = async (id: string | undefined) => {
  const { data } = await IBModuleApi.get(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/tenantbranding/${id}`,
    {
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0',
      }
    }
  );

  return data;
};